(() => {
  'use-strict';

  const mouseMoving = () => {
    document.documentElement.classList.add('-isMouse');
    document.documentElement.classList.remove('-isKeyboard');
    document.removeEventListener('mousemove', mouseMoving, false);
    // eslint-disable-next-line no-use-before-define
    document.addEventListener('keydown', keyboardFocus, false);
  };

  const keyboardFocus = (e) => {
    if (e.keyCode !== 9) { // Listen only for Tab
      return;
    }

    document.documentElement.classList.add('-isKeyboard');
    document.documentElement.classList.remove('-isMouse');
    document.removeEventListener('keydown', keyboardFocus, false);
    document.addEventListener('mousemove', mouseMoving, false);
  };

  document.addEventListener('mousemove', mouseMoving, false);
  document.addEventListener('keydown', keyboardFocus, false);
})();
